/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 11/21/17
 * Copyright All Rights Reserved
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Renders a Bootstrap form group whose children are a label and a form control
 * to be passed as the value of props.children
 *
 * @param props configure component
 */
const FormGroup = props => (
  !props.isCheckBox ? (
    <div className={classNames('form-group', props.formGroupClasses)}>
      <label className={classNames(props.labelClasses)} htmlFor={props.forValue}>
        {props.labelText}
      </label>
      {props.children}
      <span className="help-block">{props.helpBlockText ? props.helpBlockText : ''}</span>
    </div>
  ) : (
    <div className="checkbox">
      <label htmlFor={props.forValue}>
        {props.children} {props.labelText}
      </label>
    </div>
  )
);

FormGroup.defaultProps = {
  labelClasses: {},
  labelText: '',
  forValue: '',
  formGroupClasses: '',
  helpBlockText: '',
  isCheckBox: false,
};

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  forValue: PropTypes.string.isRequired,
  labelClasses: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  labelText: PropTypes.string.isRequired,
  formGroupClasses: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  helpBlockText: PropTypes.string.isRequired,
  isCheckBox: PropTypes.bool,
};

export default FormGroup;

